import { Button, Modal, Typography } from "@joonapp/web-shared"

import { useFirstQuestCompleteModalStore } from "./useFirstQuestCompleteModalStore"

const FirstQuestCompleteModal = () => {
  const { isOpen, onClose, name } = useFirstQuestCompleteModalStore()

  return (
    <Modal isOpen={isOpen} onClose={onClose} animate>
      <div
        className="flex flex-col items-center gap-6 p-6"
        style={{ width: "min(450px, 95vw)" }}
      >
        <img
          src="/images/party_popper.gif"
          alt="party-popper"
          className="w-16 h-16 mb-4"
        />
        <Typography variant="bodyBold" textAlign="center">
          Woohoo! Congrats on marking your first Quest as completed!
        </Typography>
        <div className="flex flex-col items-center gap-2">
          <Typography variant="bodySmall" textAlign="center">
            {name ?? "Your child"} earned some coins from this quest which they
            can collect from the mailman in their Joon Game App!
          </Typography>
          <img
            src="/images/redeem_from_mailman.png"
            alt="redeem-from-mailman"
            className="w-full"
          />
        </div>
        <Button
          onClick={onClose}
          buttonType="primary"
          text="Got it!"
          fullWidth
        />
      </div>
    </Modal>
  )
}

export default FirstQuestCompleteModal
